var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0014 10.3855C11.8586 10.3855 14.1941 8.04991 14.1941 5.19275C14.1941 2.33559 11.8586 0 9.0014 0C6.14423 0 3.80869 2.33559 3.80869 5.19275C3.80869 8.04991 6.14428 10.3855 9.0014 10.3855Z",
    fill: "#E22440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.913 14.5353C17.7769 14.1951 17.5956 13.8777 17.3915 13.5829C16.3484 12.0409 14.7384 11.0205 12.9244 10.7711C12.6976 10.7484 12.4482 10.7937 12.2668 10.9298C11.3144 11.6328 10.1806 11.9956 9.00145 11.9956C7.82228 11.9956 6.68851 11.6328 5.73613 10.9298C5.5547 10.7937 5.30527 10.7257 5.07853 10.7711C3.26447 11.0205 1.63183 12.0409 0.611427 13.5829C0.407347 13.8777 0.225924 14.2178 0.0898991 14.5353C0.0218869 14.6713 0.0445432 14.8301 0.112555 14.9661C0.293979 15.2836 0.520715 15.6011 0.724795 15.8732C1.04224 16.304 1.38239 16.6895 1.76789 17.0523C2.08534 17.3697 2.44815 17.6645 2.81099 17.9593C4.60236 19.2972 6.75657 20.0001 8.97879 20.0001C11.201 20.0001 13.3552 19.2972 15.1466 17.9593C15.5094 17.6872 15.8722 17.3697 16.1897 17.0523C16.5525 16.6895 16.9153 16.304 17.2328 15.8732C17.4595 15.5784 17.6637 15.2836 17.845 14.9661C17.9584 14.8301 17.981 14.6713 17.913 14.5353Z",
    fill: "#E22440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2a3b99f1c0f11624029d34811adb576e.svg";
export { ForwardRef as ReactComponent };